import { Component, Input, ViewChild, ElementRef } from '@angular/core';
import { FormGroup, Validators } from '@angular/forms';
import { DEFAULT_MAX_FILE_SIZE } from '../../consts/default-max-file-size.const';

@Component({
  selector: 'app-upload-file',
  templateUrl: './upload-file.component.html',
  styleUrls: ['./upload-file.component.scss'],
})
export class UploadFileComponent {
  @ViewChild('input') inputFile!: ElementRef;
  @Input() title: string = 'Upload file';
  @Input() form!: FormGroup | any;
  @Input() controlName!: string;
  @Input() allowMultiple: boolean = false;
  @Input() accept: string = '.jpg, .jpeg, .png, .doc, .docx, .pdf';
  @Input() isLoading = false;
  @Input() placeholder?: string;
  @Input() maxFileSize: number = DEFAULT_MAX_FILE_SIZE;
  errorMessage = '';
  files: File[] = [];
  isDraggingOver: boolean = false;

  handleInputFileClick(): void {
    this.inputFile.nativeElement.click();
  }

  handleFileInput(event: Event): void {
    const fileList: FileList = (event.target as HTMLInputElement).files!;
    this.addFiles(Array.from(fileList));
  }

  addFiles(files: File[]): void {
    const validFiles: File[] = [];
    this.clearError();

    files.forEach((file) => {
      if (file.size <= this.maxFileSize) {
        validFiles.push(file);
      } else {
        this.errorMessage = `Some files exceed the size limit of ${
          this.maxFileSize / (1024 * 1024)
        } MB. Only valid files are uploaded`;
      }
    });

    if (!validFiles.length) {
      this.errorMessage = `Please upload a file smaller than ${(
        this.maxFileSize /
        (1024 * 1024)
      ).toFixed(2)} MB. Allowed file types: ${this.accept}.`;
    }

    if (this.allowMultiple) {
      this.files = [...this.files, ...validFiles];
    } else {
      this.files = validFiles.length > 0 ? [validFiles[0]] : [];
    }

    this.form.get(this.controlName)?.patchValue(this.files);
    this.form.get(this.controlName)?.updateValueAndValidity();
  }

  clearError() {
    this.errorMessage = '';
  }
  removeFile(index: number): void {
    this.clearError();
    this.files.splice(index, 1);
    this.form.get(this.controlName)?.patchValue(this.files);
    this.form.get(this.controlName)?.updateValueAndValidity();
  }

  protected readonly Validators = Validators;

  handleDrop(event: DragEvent): void {
    event.preventDefault();
    event.stopPropagation();
    this.isDraggingOver = false;

    if (event.dataTransfer && event.dataTransfer.files) {
      const droppedFiles = Array.from(event.dataTransfer.files);
      this.addFiles(droppedFiles);
    }
  }

  handleDragOver(event: DragEvent): void {
    event.preventDefault();
    event.stopPropagation();
    this.isDraggingOver = true;
  }

  handleDragLeave(event: DragEvent): void {
    event.preventDefault();
    event.stopPropagation();
    this.isDraggingOver = false;
  }
}
